module.exports = __webpack_public_path__ + "ab26c7d0ebda8d9e8206f5fe1a863a83.svg";